<template>
<v-layout row wrap>

<v-flex xs12 sm3 style="margin-right:10px">
  <div
    :style="containerStyle"
    class="vertical-tabs elevation-2"
    :class="{'vertical-tabs--vertical-text': verticalText, 'vertical-tabs--horizontal-text': !verticalText}"
    
  >
    <v-tabs
      :value="value"
      @change="$emit('tabchange', $event)"
      :show-arrows="verticalText"
      color="color"
      :slider-color="sliderColor"
      :style="tabsStyle"
      :dark="darkmode"
    >
      <v-tab v-for="item in items" :key="item">{{ item }}</v-tab>
    </v-tabs>

  </div>
</v-flex>
  <v-flex xs12 sm8>
 <slot name="titems"></slot>

  </v-flex>
  </v-layout>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "vertical-tabs",
  props: {
    color: String,
    height: {
      type: [Number, String],
      default: 300
    },
    items: Array,
    sliderColor: String,
    value: null,
    verticalText: Boolean
  },
  computed: {
    ...mapGetters({
      darkmode: "settings/DARKMODE"
    }),
    containerStyle() {
      return this.verticalText
        ? {
            height: isNaN(this.height) ? this.height : `${this.height}px`
            
          }
        : {
            height: 48 * this.items.length + "px"
          };
          
    },
    tabsStyle() {
      return this.verticalText
        ? {
            width: isNaN(this.height) ? this.height : `${this.height}px`
          }
        : {};
    }
  }
};
</script>

<style scoped>
.vertical-tabs {
  overflow: hidden;
}
.vertical-tabs--horizontal-text .v-tabs {
  transform: rotate(90deg);
  transform-origin: 100px 100px;
  height: 200px;
}
.vertical-tabs--horizontal-text .v-tabs >>> .v-tabs__container {
  height: 200px;
}
.vertical-tabs--horizontal-text .v-tabs >>> .v-tabs__div {
  width: 48px;
  height: 200px;
  display: inline-block;
}
.vertical-tabs--horizontal-text .v-tabs >>> .v-tabs__item {
  transform: rotate(-90deg);
  transform-origin: 100px 100px;
  width: 200px;
  height: 48px;
  display: block;
  text-align: left;
  line-height: 36px;
  white-space: pre;
  overflow: hidden;
  text-overflow: ellipsis;
  border-bottom: 1px #333 solid;
}
.vertical-tabs--vertical-text {
  width: 48px;
}
.vertical-tabs--vertical-text .v-tabs {
  transform: rotate(90deg);
  transform-origin: 24px 24px;
}
.vertical-tabs--vertical-text .v-tabs >>> .v-tabs__item {
  transform: rotate(180deg);
}
.vertical-tabs--vertical-text .v-tabs >>> .v-tabs__slider-wrapper {
  top: 0;
  bottom: auto;
}
</style>


// WEBPACK FOOTER //
// resources/assets/js/components/VerticalTabs.vue